import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmBannerInMetroShape",
  "use": "svg-icon-cpmBannerInMetroShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-cpmBannerInMetroShape\"><path d=\"M14.9 12.34L11.161 3 8 8.46 4.851 3l-3.75 9.34H0v1.416h5.658V12.34h-.845l.819-2.325L8 13.857l2.368-3.842.82 2.325h-.846v1.416H16V12.34z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol